import React from 'react';
import { connect } from 'react-redux';
import { setFormData } from '../actionCreators/setFormData';
import { setFormFile } from '../actionCreators/setFormFile';
import { bindActionCreators } from 'redux';
import { getActivitiesInDomain } from '../actionCreators/getActivitiesInDomain';
import { selectActivityType } from '../actionCreators/selectActivityType';
import './FieldBuilder.css'

class FieldBuilder extends React.Component {

    constructor(props) {

        super(props);

        this.onChange = this.onChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }

    inputBuilder() {

        if (this.props.formOptions.Volunteers && this.props.field.Type === 'list') {
            return (
                <div>
                    <label
                        htmlFor={this.props.field.Field}
                    >
                        {this.props.field.Field}
                    </label>
                    <input
                        name={this.props.field.Field}
                        list={this.props.field.Field}
                        onBlur={this.onChange}
                    />
                    <datalist id={this.props.field.Field}>
                        {this.props.formOptions.Volunteers.map(
                            function (option, index) {
                                return (
                                    <option
                                        value={option.Name}
                                        key={index}
                                    />
                                )
                            }
                        )}
                    </datalist>
                </div>
            )
        }
        else if (this.props.field.Type === 'select') {
            if (this.props[this.props.field.Source]) {
                return (
                    <div>
                        <label
                            htmlFor={this.props.field.Field}
                        >
                            {this.props.field.Field}
                        </label>
                        <select
                            name={this.props.field.Field}
                            onChange={this.props.field.Dependable ? this.handleOnChange : this.onChange}
                        >
                            {this.props.field.Field === "Domeniu" ? <option /> : null}
                            {this.props.field.Field === "Nume" ? <option /> : null}  
                            {this.props[this.props.field.Source].map(
                                function (option, index) {
                                    return (
                                        <option
                                            value={option}
                                            key={index}
                                        >
                                            {option}
                                        </option>
                                    )
                                }
                            )}
                        </select>
                    </div>
                )
            }
            else {
                return (
                    <div>
                        <label
                            htmlFor={this.props.field.Field}
                        >
                            {this.props.field.Field}
                        </label>
                        <select
                            name={this.props.field.Field}
                            onChange={this.props.field.Dependable ? this.handleOnChange : this.onChange}
                        >
                            <option />
                        </select>
                    </div>
                )
            }

        }
        else if (this.props.field.Field === "Data_sfarsit") {
            return (
                <div>
                    {
                        this.props.activityType === "De o zi" ? '' :
                            <label
                                htmlFor={this.props.field.Field}
                            >
                                {this.props.field.Field}
                            </label>
                    }
                    <input
                        type={this.props.activityType === "De o zi" ? "hidden" : this.props.field.Type}
                        name={this.props.field.Field}
                        onChange={this.props.field.Type === 'file' ? this.handleFileChange : this.onChange}
                        value={this.props.formData[this.props.field.Field] ? this.props.formData[this.props.field.Field] : ''}
                    />
                </div>
            )
        }
        else if(this.props.field.Type === "textarea") {
            return (
                <div>
                    <label
                        htmlFor={this.props.field.Field}
                    >
                        {this.props.field.Field}
                    </label>
                    <textarea
                        type={this.props.field.Type}
                        name={this.props.field.Field}
                        onChange={this.onChange}
                        value={this.props.formData[this.props.field.Field] ? this.props.formData[this.props.field.Field] : ''}
                    />
                </div>
            )
        }
        else {
            return (
                <div>
                    <label
                        htmlFor={this.props.field.Field}
                    >
                        {this.props.field.Field}
                    </label>
                    <input
                        type={this.props.field.Type}
                        name={this.props.field.Field}
                        onChange={this.props.field.Type === 'file' ? this.handleFileChange : this.onChange}
                        value={this.props.formData[this.props.field.Field] ? this.props.formData[this.props.field.Field] : ''}
                    />
                </div>
            )
        }
    }

    onChange(e) {

        if (e.target.list) {

            let data = this.props.formOptions.Volunteers.find(ele => {

                return ele.Name === e.target.value
            })

            if (data) {

                let volunteer = {
                    target: {
                        name: 'Id_voluntar',
                        value: data.Id
                    }
                }
                this.props.setFormData(volunteer);
            }
        }
        else {
            this.props.setFormData(e);
        }
    }

    handleOnChange(e) {
        if (e.target.name === "Tip_activitate") {
            this.props.selectActivityType(e.target.value);
        } 
        else {
            this.props.getActivities(e.target.value);
        } 
        this.onChange(e);
    }

    handleFileChange(e) {

        this.props.setFormFile(e);

    }

    render() {
        if (this.props.field.Type !== 'hidden') {
            return (
                <div className = "formField">
                    {this.inputBuilder()}
                </div>
            )
        }
        else {
            return ''
        }
    }
}

function mapStateToProps(state) {

    return {
        formData: state.formData.formData,
        view: state.activeOption,
        formOptions: state.formOptions,
        domains: state.domains,
        activities: state.activities,
        types: state.types,
        activityType: state.activityType
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        setFormData: setFormData,
        setFormFile: setFormFile,
        getActivities: getActivitiesInDomain,
        selectActivityType: selectActivityType
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(FieldBuilder);


// WEBPACK FOOTER //
// ./src/formBuilder/FieldBuilder.js